import HttpService from "./htttp.service";

class AuthService {
  // authEndpoint = process.env.API_URL;

  login = async (payload) => {
    const loginEndpoint = 'login';
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = 'register';
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = 'logout';
    return await HttpService.post(logoutEndpoint);
  };

  forgotPassword = async (payload) => {
    const forgotPassword = 'password-forgot';
    return await HttpService.post(forgotPassword, payload);
  };

  resetPassword = async (credentials) => {
    const resetPassword = 'password-reset';
    return await HttpService.post(resetPassword, credentials);
  };

  getProfile = async () => {
    const getProfile = 'me';
    const response = await HttpService.get(getProfile);

    // [NEW] Demo User Logic: Check Session Storage for Tutorials
    try {
      if (response?.data?.attributes?.role === "demo_viewer") {
        // Cache role for updateProfile to use
        sessionStorage.setItem('demo_role_cache', "demo_viewer");

        const localTutorials = JSON.parse(sessionStorage.getItem('demo_completed_tutorials') || "[]");
        const serverTutorials = response.data.attributes.completed_tutorials || [];

        // Merge unique
        const merged = [...new Set([...serverTutorials, ...localTutorials])];
        response.data.attributes.completed_tutorials = merged;
      } else {
        sessionStorage.removeItem('demo_role_cache'); // Clear if not demo
      }
    } catch (e) {
      console.warn("Error processing demo tutorials:", e);
    }

    return response;
  };

  updateProfile = async (newInfo) => {
    // [NEW] Demo User Logic: Intercept Tutorial Updates
    const isDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";

    // Check if we are ONLY updating tutorials? Or if the payload has tutorials
    // The structure passed is usually { data: { attributes: { completed_tutorials: [...] } } }
    const tutorialsUpdate = newInfo?.data?.attributes?.completed_tutorials;

    if (isDemo && tutorialsUpdate) {
      // Save to session storage
      // Note: The UI sends the FULL LIST of completed tutorials usually.
      // If it sends incremental, we might need to merge, but typically it's "set value".
      sessionStorage.setItem('demo_completed_tutorials', JSON.stringify(tutorialsUpdate));

      // If there are OTHER fields being updated (like name/password), we might still want to call the backend?
      // But for demo user, usually updateProfile is blocked entirely.
      // So we return a FAKE success response immediately.

      return {
        data: {
          type: 'users',
          id: 'demo-id', // dummy
          attributes: {
            completed_tutorials: tutorialsUpdate,
            // We might need to echo back other attributes if the UI expects them?
            // Typically UI just checks for 200 OK.
          }
        }
      };
    }

    const updateProfile = "me";
    return await HttpService.patch(updateProfile, newInfo);
  };

  resendVerificationLink = async (payload) => {
    const resendVerification = "resend-verification";
    return await HttpService.post(resendVerification, payload);
  };

  verifyEmail = async (payload) => {
    const verifyEmailEndpoint = "verify-email";
    return await HttpService.post(verifyEmailEndpoint, payload);
  };

  requestDemo = async (payload) => {
    const endpoint = "demo-request";
    return await HttpService.post(endpoint, payload);
  };

  demoLogin = async () => {
    const endpoint = "demo-login";
    return await HttpService.post(endpoint);
  };

  googleOneTapLogin = async (credential, invitationToken = null) => {
    const endpoint = "oauth/google/one-tap";
    const payload = {
      data: {
        type: "google-one-tap",
        attributes: { credential, invitationToken }
      }
    };
    return await HttpService.post(endpoint, payload);
  };

  initiateFederatedLogin = async (provider, invitationToken = null) => {
    let endpoint = `oauth/${provider}`;
    if (invitationToken) {
      endpoint += `?invitationToken=${invitationToken}`;
    }
    try {
      const response = await HttpService.get(endpoint);
      if (response.oauthUrl) {
        window.location.href = response.oauthUrl; // Redirect to provider
      } else {
        throw new Error("OAuth URL not received");
      }
    } catch (error) {
      console.error(`Error initiating ${provider} federated login:`, error.message);
      throw error;
    }
  };

  handleFederatedCallback = async (provider, code) => {
    const endpoint = `oauth/${provider}/callback?code=${code}`;
    try {
      const response = await HttpService.get(endpoint);
      return response; // Should contain tokens or redirect info
    } catch (error) {
      console.error(`Error handling ${provider} callback:`, error.message);
      throw error;
    }
  };

  reactivateAccount = async (credentials) => {
    const endpoint = 'reactivate-account';
    return await HttpService.post(endpoint, credentials);
  };

  uploadProfileImage = async (formData) => {
    const endpoint = 'me/profile-image';
    return await HttpService.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

}

export default new AuthService();
